import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconCaretLeft$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCaretLeft extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'bfc44d71f4f7ff4017ff3e92a6693c178ffe0261', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'd53296c0e3254ad1f048c25ba2bc057958603673', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '5baba1a513370e9c584727902f8f872df952ec7e', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m8.21 11.21 5.28 5.28a.3.3 0 0 0 .51-.21V5.72a.3.3 0 0 0-.51-.21l-5.28 5.28a.29.29 0 0 0 0 .42", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-caret-left", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-caret-left"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-caret-left":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCaretLeft$1);
            }
            break;
    } });
}

const CosmosIconCaretLeft = CosmosIconCaretLeft$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCaretLeft, defineCustomElement };
